import { ApiKeyModel } from 'src/models/api-key-model'
import { BASE_URL } from '../constants/url'
import { client } from './baseService'

export const getApiKeys = async (options?) => {
  try {
    const res = await client().get(`${BASE_URL}/api-key`, options)
    return res.data
  } catch (error) {
    return false
  }
}

export const createApiKey = async (
  apiKey: ApiKeyModel | any
): Promise<ApiKeyModel | boolean> => {
  try {
    const res = await client().post(`${BASE_URL}/api-key`, apiKey)
    return res.data
  } catch (error) {
    return false
  }
}

export const deleteApiKeyById = async (
  id: string | number
): Promise<ApiKeyModel | boolean> => {
  try {
    const res = await client().delete(`${BASE_URL}/api-key/${id}`)
    return true
  } catch (error) {
    return false
  }
}
